// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dNub","fullView":"styles_fullView__flJWt"};